module.exports = __webpack_public_path__ + "img/localfluence.11cdf96d.svg";